<template>
  <main-content>
    <kt-panel>
      <kt-panel-body v-if="$can('read', 'ticket')">
        <ManageAccessForm :action="createTicket" />
      </kt-panel-body>
      <kt-panel-body v-else>
        <ticket-form :action="createTicket" />
      </kt-panel-body>
    </kt-panel>
  </main-content>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { ticketService } from '@/common/api.service'
import ticketForm from './components/form'
import mainContent from '@/components/main-content'
import ManageAccessForm from "@/views/ticket/components/manageAccessForm.vue";

export default {
    components: {
        ticketForm,
        mainContent,
      ManageAccessForm,
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchForSelect')
        })
    },
    methods: {
        createTicket(e, query) {
            let form = $(e.target)
            let btn = $('#submit_button')

            form.validate({
                ignore: ":hidden",

                rules: {
                    subject: {
                        required: true,
                    },
                    category_id: {
                        required: true,
                    },
                    content: {
                        required: true,
                    },
                    priority: {
                        required: true,
                    },
                    created_for: {
                      required: true,
                    }
                },
            });


            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            const ticketServiceMethod = this.$can('read', 'ticket')
                ? ticketService.createTicketAsAdmin
                : ticketService.create

            ticketServiceMethod(query)

            .then(response => {
                this.$router.push('/tickets')
                this.showMsg(form, 'success', response.data.message)
                this.$store.dispatch('badgeCounter/countData')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>

</style>